// src/api/requestApi.js
import api from './api';

export const getAllRequests = () => {
  return api.get('/req/requests');
};

export const getRequestById = (id) => {
  return api.get(`/req/requests/${id}`);
};

export const createRequest = (data) => {
  return api.post('/req/requests', data);
};

export const updateRequest = (id, data) => {
  return api.put(`/req/requests/${id}`, data);
};

export const deleteRequest = (id) => {
  return api.delete(`/req/requests/${id}`);
};

export const updateRequestState = (id, state) => {
  return api.patch(`/req/requests/${id}/state`, { state });
};
